import { SxProps, Theme } from '@mui/material';

export const AccountSummaryTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
	marginBottom: '20px',
	textTransform: 'uppercase',
};

export const AccountSummaryLinkButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
	alignSelf: { xs: 'center', md: 'flex-start' },
	marginTop: '20px !important',
	'&:hover': {
		textDecoration: 'underline',
	},
});

export const AccountSummaryOrdersLinkButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
	alignSelf: { xs: 'center', md: 'flex-start' },
	marginTop: '20px !important',
	'&:hover': {
		textDecoration: 'underline',
	},
});

export const AccountSummaryMonederoContainerSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'row',
	fontFamily: 'Roboto',
	border: '1px solid #C9C9C9',
	width: 'max-content',
	alignItems: 'stretch',
	borderRadius: '4px',
});

export const AccountSummaryMonederoTextSx: SxProps<Theme> = (theme) => ({
	padding: '20px 18px',
	maxWidth: '144px',
	textTransform: 'uppercase',
	fontSize: '14px',
	lineHeight: '18px',
	fontWeight: '900',
});

export const AccountSummaryMonederoAmountContainerSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexGrow: '1',
	background: '#F0F7FF',
	alignItems: 'center',
	minWidth: '176px',
	color: 'white',
	borderRadius: '0 4px 4px 0',
});

export const AccountSummaryMonederoAmountSx: SxProps<Theme> = (theme) => ({
	color: '#000000',
	margin: 'auto',
	fontSize: '20px',
	fontWeight: '700',
});
